/* lx PDP gallery (lx_design only):
   - thumbnail strip: prev/next arrows scroll the strip horizontally (Dawn's slider-component scrolled the page instead)
   - video: a close button returns to the first photo, and switching thumbnails pauses the video */
(function () {
  function initStrip(ts) {
    if (ts.dataset.lxGal) return;
    ts.dataset.lxGal = '1';
    var list = ts.querySelector('.thumbnail-list');
    var prev = ts.querySelector('.slider-button--prev');
    var next = ts.querySelector('.slider-button--next');
    if (!list || !prev || !next) return;
    function sync() {
      // re-query: the theme's slider can replace the buttons
      prev = ts.querySelector('.slider-button--prev') || prev;
      next = ts.querySelector('.slider-button--next') || next;
      var max = list.scrollWidth - list.clientWidth - 1;
      // Dawn's slider-component sets [disabled] from its own (vertical) maths; we own the state via a class.
      if (prev.disabled) prev.disabled = false;
      if (next.disabled) next.disabled = false;
      prev.classList.toggle('lx-off', list.scrollLeft <= 0);
      next.classList.toggle('lx-off', list.scrollLeft >= max);
      prev.setAttribute('aria-disabled', list.scrollLeft <= 0 ? 'true' : 'false');
      next.setAttribute('aria-disabled', list.scrollLeft >= max ? 'true' : 'false');
      ts.classList.toggle('lx-thumbs-overflow', max > 0);
    }
    function go(dir, e) {
      if (!window.matchMedia('(min-width: 750px)').matches) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      list.scrollBy({ left: dir * Math.max(list.clientWidth * 0.8, 80), behavior: 'smooth' });
    }
    // capture on the strip so this runs before Dawn's slider-component handler on the buttons
    ts.addEventListener('click', function (e) {
      if (e.target.closest('.slider-button--prev')) go(-1, e);
      else if (e.target.closest('.slider-button--next')) go(1, e);
    }, true);
    if (window.MutationObserver) new MutationObserver(sync).observe(ts, { attributes: true, subtree: true, childList: true, attributeFilter: ['disabled'] });
    list.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    // keep the active thumbnail in view (keyboard Tab / gallery change)
    list.addEventListener('focusin', function (e) {
      var li = e.target.closest('.thumbnail-list__item');
      if (li) li.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
    sync();
    setTimeout(sync, 800);
  }

  function pauseAll(gallery) {
    gallery.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} });
    gallery.querySelectorAll('iframe').forEach(function (f) {
      try {
        f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        f.contentWindow.postMessage('{"method":"pause"}', '*');
      } catch (e) {}
    });
  }

  function addClose(gallery, dm) {
    if (dm.querySelector('.lx-video-close')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lx-video-close';
    b.setAttribute('aria-label', gallery.getAttribute('data-lx-close') || 'Close');
    b.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      pauseAll(gallery);
      var first = Array.prototype.find.call(
        gallery.querySelectorAll('.thumbnail-list__item'),
        function (li) { return li.offsetParent && !li.querySelector('.thumbnail__badge'); }
      );
      var btn = first && first.querySelector('button');
      if (btn) { btn.click(); btn.focus(); }
    });
    dm.appendChild(b);
  }

  function initGallery(g) {
    if (g.dataset.lxGal) return;
    g.dataset.lxGal = '1';
    g.querySelectorAll('thumbnail-slider').forEach(initStrip);
    g.addEventListener('click', function (e) {
      if (e.target.closest('.thumbnail-list__item button')) pauseAll(g);
    }, true);
    g.querySelectorAll('deferred-media').forEach(function (dm) {
      if (dm.hasAttribute('loaded')) addClose(g, dm);
      new MutationObserver(function () { if (dm.hasAttribute('loaded')) addClose(g, dm); })
        .observe(dm, { attributes: true, attributeFilter: ['loaded'] });
    });
  }

  function run() { document.querySelectorAll('.product--lx media-gallery').forEach(initGallery); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
